import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center"
        data-testid="auth-checking"
      >
        <div className="sov-sigil mb-5" />
        <div className="dot-loader"><span /><span /><span /></div>
        <div className="mt-6 font-mono text-[10px] tracking-[0.3em] text-ivory-3 uppercase">
          Verifying Sovereign Credentials
        </div>
      </div>
    );
  }

  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
